// extracted by mini-css-extract-plugin
module.exports = {"search-dimmer":"style_search-dimmer__72lRs","search-wrap":"style_search-wrap__2d3ks","toggle":"style_toggle__1YTVd"};